import { usePrintStore } from "reusable/printing/PrintStore"
import CheckIcon from "@mui/icons-material/Check"
import ButtonWithProgress from "reusable/mui/progress-button/ButtonWithProgress"
import { observer } from "mobx-react-lite"
import useStore from "reusable/mobx-store-utils"
import DownloadPdfButtonStore from "reusable/printing/DownloadPdfButtonStore"
import { useEffect } from "react"

interface DownloadPdfButtonProps {
   /** Title of the document if downloading the current page */
   docTitle: string
   /** If set, we download the file from this link */
   documentUrl?: string | undefined
   /** If set, we check the printStore if it is already generating and tap into that promise */
   docId?: string
}

export default observer(function DownloadPdfButton({ docTitle, documentUrl, docId }: DownloadPdfButtonProps) {
   const printStore = usePrintStore()
   const downloadPdfButtonStore = useStore((sp) => new DownloadPdfButtonStore(sp), { printStore, docTitle, documentUrl, docId })

   useEffect(() => {
      (window as any).__GAP_DOC_TITLE = docTitle
   }, [docTitle])

   return <ButtonWithProgress
      {...downloadPdfButtonStore.loader.isLoading ? { icon: <CheckIcon /> } : {}}
      variant="contained"
      onClick={downloadPdfButtonStore.download}
      disabled={printStore.downloadLoader.isLoading || downloadPdfButtonStore.loader.isLoading}
      loading={printStore.downloadLoader.isLoading}
   >
      {printStore.downloadLoader.isLoading
         ? 'Preparing PDF'
         : downloadPdfButtonStore.loader.isLoading
            ? 'Downloaded'
            : 'Download PDF'
      }
   </ButtonWithProgress>
})
